import { createAction, props } from '@ngrx/store';

export const loadPaymentRunTabControls = createAction('[PaymentRunTabControl] Load PaymentRunTabControls', props<{ tabIndex: number }>());
